module.exports = __webpack_public_path__ + "static/media/patient1.703dc77a.jpg";